export default "__VITE_ASSET__Chyb25mL__"